export class EventNames {
    static readonly CartChanged: string = 'CartChanged';
    static readonly CartValidated: string = 'CartValidated';
    static readonly CartTotalQuantityChanged: string = 'CartTotalQuantityChanged';
    static readonly ToggleCart: string = 'ToggleCart';
    static readonly ShowUpdatedCart: string = 'ShowUpdatedCart';
    static readonly RequestForUpdatingCart: string = 'RequestForUpdatingCart';
    static readonly CloseSearch: string = 'CloseSearch';
    static readonly CloseNavigation: string = 'CloseNavigation';
    static readonly HideHeader: string = 'HideHeader';
    static readonly ScrollLockChange: string = 'ScrollLockChange';
    static readonly ErrorOccured: string = 'ErrorOccured';
    static readonly CartMerged: string = 'CartMerged';
    static readonly Search: string = 'Search';
    static readonly ResetSearch: string = 'ResetSearch';
    static readonly RefreshPorterBuddy: string = 'RefreshPorterBuddy';
    static readonly RefreshPostNord: string = 'RefreshPostNord';
    static readonly RefreshPostNHome: string = 'RefreshPostNHome';
    static readonly RefreshHeltHjem: string = 'RefreshHeltHjem';
    static readonly SessionExpired: string = 'SessionExpired';
    static readonly RefreshShippingInfo: string = 'RefreshShippingInfo';
    static readonly DeliveryProps: string = 'DeliveryProps';
    static readonly ActionRequiresLogin: string = 'ActionRequiresLogin';
    static readonly FatalError: string = 'FatalError';
    static readonly AddedFirstFavourite: string = 'AddedFirstFavourite';
    static readonly RxItemsRemoved: string = 'RxItemsRemoved';
    static readonly UserDetailsLoaded: string = 'UserDetailsLoaded';
    static readonly RecommendationsLoaded: string = 'RecommendationsLoaded';
    static readonly CartFromDifferentWarehouse: string = 'CardLoadedFromDifferentWarehouse';
    static readonly IframeFocused: string = 'IframeFocused';
    static readonly RxRemovedFromCart: string = 'RxRemovedFromCart';
    static readonly RxLogoutRequest: string = 'RxLogoutRequest';
    static readonly RxLoginRequest: string = 'RxLoginRequest';
    static readonly EComLogoutRequest: string = 'EComLogoutRequest';
    static readonly HideAlertRibbon: string = 'HideAlertRibbon';
    static readonly CooledProductsConflict: string = 'CooledProductsConflict';
    static readonly OpenDeliveryModal: string = 'OpenDeliveryModal';
}
